export default __webpack_public_path__ + "static/media/about-us-image.80322331.jpg";